export const API_ENDPOINT = new URL(import.meta.env.VITE_API_ENDPOINT);